export default __webpack_public_path__ + "static/media/main-image-mobile.e25c5106.jpg";